import { render, staticRenderFns } from "./LessonCategory.vue?vue&type=template&id=5b9ce3f9&"
import script from "./LessonCategory.vue?vue&type=script&lang=js&"
export * from "./LessonCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports